import MailChimp from "../components/MailChimp";
import Birb from "../assets/BirbBG.png";
import LukeVolunteer from "../assets/LukeVolunteer.png";
import Group1 from "../assets/volunteering/Group1.jpg";
import {Donate} from "../components/Header";
import React, { useRef } from "react";
import { motion, useScroll } from "framer-motion";
import { useParallax } from "./About";
import { NavLink } from "react-router-dom";
import cn from "classnames";
import YardSigns from "../assets/YardSigns.jpg";

const Background = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll();
  const y1 = useParallax(scrollYProgress, -30);
  const y3 = useParallax(scrollYProgress, -100);
  const imgList = [
    { img: Group1, style: { y: y1, top: "20px" }, imgStyle: { width: "100%"} },
  ];

  return (
    <section ref={ref} className={"fixed w-full h-full pointer-events-none"}>
      {imgList.map(({ img, style, imgStyle }, index) => (
        <motion.div
          key={`image-${index}`}
          className={"absolute h-[150vh] w-[150vw] -left-[25vw]"}
          style={style}
        >
          <img
            className={"h-full w-full object-cover"}
            src={img}
            alt={img}
            style={imgStyle}
          />
        </motion.div>
      ))}
    </section>
  );
};

export const Contact = () => {
	return (
    <div
      className={
        "flex flex-1 flex-col items-start w-full h-full gap-4 max-w-100vw overflow-x-hidden"
      }
    >
      <Background />
      <div
        className={
          "pb-8 w-full flex flex-col items-center mt-32 justify-center"
        }
      >
        <div
          className={
            "flex flex-col text-center items-center z-100 h-max w-auto relative justify-center bg-white/70 backdrop-blur m-8 p-2 rounded"
          }
        >
          <h1 className={"text-4xl py-2"}>Yard Signs</h1>
          <img
            alt="Yard Signs"
            className="w-[75vw] sm:w-[28rem] lg:w-[32rem] rounded-2xl"
            src={YardSigns}
          />
          <span className={"flex flex-col text-xl p-4"}>
            <p>
              Live in or near{" "}
              <NavLink
                key={"link-to-district-60"}
                to={"/district"}
                className={cn(
                  "w-min min-w-max cursor-pointer transition-colors hover:text-black font-bold",
                )}
              >
                House District 60
              </NavLink>
              ?
            </p>
            <p>
              Email{" "}
              <a
                href="mailto:lukefornm@gmail.com?subject=LukeForNM Yard Signs"
                className="underline"
              >
                LukeForNM@gmail.com
              </a>{" "}
              with the subject line <b>"LukeForNM Yard Signs"</b> to get one for
              free!
            </p>
          </span>
        </div>
      </div>
      <div
        className={
          "inline-flex text-white flex-col justify-start items-center px-8 h-max w-full"
        }
      >
        <div
          className={
            "bg-white/70 backdrop-blur-sm p-4 rounded text-xl text-black flex flex-col gap-4"
          }
        >
          <MailChimp />
        </div>
      </div>
      <div className={"flex items-center justify-center w-full"}>
        <img
          className={
            "w-full h-full max-h-[60vh] max-w-full object-contain z-10"
          }
          src={LukeVolunteer}
          alt={"Volunteer"}
        />
      </div>
      <div className={"pb-8 w-full flex justify-center"}>
        <div
          className={
            "flex flex-col md:flex-row gap-5 text-center items-center z-100 h-max w-max relative justify-center bg-white/80 backdrop-blur m-8 px-8 py-2 rounded"
          }
        >
          <span>
            Every donation helps us fight for{" "}
            <b>
              New Mexican Universal Healthcare, Affordable Housing, Protecting
              our Environment, and more.
            </b>
          </span>
          <Donate />
        </div>
      </div>
    </div>
  );
}
